import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Bewusst ohne api-Client: der Endpunkt braucht keine Anmeldung und keinen
// Silent-Refresh, und die Antwort ist absichtlich immer dieselbe.
const API = "/ca/api/v1/auth";

export default function Forgot() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch(`${API}/forgot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      // Fehler des Servers muessen sichtbar werden. Eine Erfolgsmeldung trotz
      // Ablehnung ist eine Luege in der Oberflaeche.
      if (!res.ok) {
        let detail = t("auth.forgotFailed");
        try {
          const d = await res.json();
          if (d?.detail) detail = typeof d.detail === "string" ? d.detail : detail;
        } catch { /* Antwort ohne JSON */ }
        setError(detail);
        return;
      }
      setOk(true);
    } catch {
      setError(t("auth.forgotFailed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4">
      <h1 className="text-5xl font-serif font-semibold text-ca-brand tracking-tight mb-2">
        Nudging Bloom
      </h1>
      <p className="text-ca-ink-muted uppercase tracking-widest font-bold text-sm mb-12">
        {t("auth.tagline")}
      </p>

      <form
        onSubmit={submit}
        className="bg-ca-card rounded-3xl p-10 w-full max-w-md border border-ca-surface-border space-y-6"
      >
        <h2 className="text-2xl font-black text-ca-surface-ink uppercase tracking-tight">
          {t("auth.forgotTitle")}
        </h2>

        {ok ? (
          <p className="text-ca-surface-ink text-sm">{t("auth.forgotSent")}</p>
        ) : (
          <>
            <p className="text-ca-surface-muted text-sm">{t("auth.forgotIntro")}</p>
            <div>
              <label className="text-xs font-black uppercase text-ca-surface-muted tracking-widest mb-2 block">
                {t("auth.email")}
              </label>
              <input
                type="email"
                name="email"
                id="forgot-email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white border border-ca-surface-border rounded-xl px-5 py-3 text-ca-surface-ink outline-none focus:border-ca-accent"
                required
              />
            </div>
            {error && <p className="text-verdict-red text-sm">{error}</p>}
            <button
              type="submit"
              disabled={busy}
              className="w-full py-4 bg-ca-accent text-ca-brand font-black uppercase tracking-widest rounded-xl shadow-xl hover:scale-[1.02] disabled:opacity-50 transition-all active:scale-95"
            >
              {busy ? "..." : t("auth.forgotButton")}
            </button>
          </>
        )}

        <p className="text-center text-sm text-ca-surface-muted">
          <Link to="/login" className="text-ca-surface-accent hover:underline">
            {t("auth.backToLogin")}
          </Link>
        </p>
      </form>
    </div>
  );
}
